import { render, staticRenderFns } from "./SupportSettingsListItem.vue?vue&type=template&id=5429ea6c&scoped=true&"
import script from "./SupportSettingsListItem.vue?vue&type=script&lang=js&"
export * from "./SupportSettingsListItem.vue?vue&type=script&lang=js&"
import style0 from "./SupportSettingsListItem.vue?vue&type=style&index=0&id=5429ea6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5429ea6c",
  null
  
)

export default component.exports